import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import UpgradeRecruiterAccount from 'scenes/Dialog/components/UpgradeRecruiterAccount';

import { LinkBuilder } from 'helpers/link-builder';
import { Role } from 'helpers/user';

const InboxItemFrom = props => {
  const { user, message } = props;

  const {
    Direction,
    FromCandidateID,
    FromName,
    FromCompanyName,
    FromCompanyUrlAlias,
    FromCompanyActive,
    FromViewProfile,
    FromViewAsRecruiter,
    FromIsActiveCandidate,
  } = message;

  const [viewProfile, viewAsRecruiter] = useMemo(
    () => [FromViewProfile === 'Yes', FromViewAsRecruiter === 'Yes'],
    [FromViewProfile, FromViewAsRecruiter]
  );

  let profileLink =
    (!Role.isCandidate(user) && Role.isRecruiterDefault(user)) ||
    (!Role.isRecruiter(user) && !Role.isCandidate(user))
      ? '#'
      : LinkBuilder.getProfileLink(FromCandidateID);

  const onClickProfileLink = (e, user) => {
    if (!Role.isCandidate(user) && Role.isRecruiterDefault(user)) {
      UpgradeRecruiterAccount();
      e.preventDefault();
    } else if (!Role.isRecruiter(user) && !Role.isCandidate(user, true)) {
      e.preventDefault();
    }
  };

  const isLink =
    FromIsActiveCandidate === 'Yes' &&
    !(
      (!viewProfile && !viewAsRecruiter) ||
      (Role.isRecruiter(user) && !Role.isCandidate(user) && !viewAsRecruiter) ||
      (!Role.isRecruiter(user) && Role.isCandidate(user) && !viewProfile)
    );

  const firmLink =
    FromCompanyActive === 'Yes'
      ? LinkBuilder.getFirmLink(FromCompanyUrlAlias)
      : null;

  return (
    <>
      <div className="inbox-item__person">
        <span className="inbox-item__link">
          {isLink ? (
            <NavLink
              className="inbox-item__title"
              to={profileLink}
              onClick={e => onClickProfileLink(e, user)}
            >
              {FromName}
            </NavLink>
          ) : (
            <span className="inbox-item__title inbox-item__title--linkless">
              {FromName}
            </span>
          )}
        </span>
      </div>
      {Direction === 'Received' && FromCompanyName && (
        <div className="inbox-item__firm-wrap">
          {firmLink ? (
            <NavLink className="inbox-item__firm" to={firmLink}>
              {FromCompanyName}
            </NavLink>
          ) : (
            <strong>{FromCompanyName}</strong>
          )}
        </div>
      )}
    </>
  );
};

InboxItemFrom.propTypes = {
  user: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired,
};

export default InboxItemFrom;
